import type { Plugin } from 'bundles/coursera-toolbar/types/Plugin';

/** Settings is fixed at the end of the toolbar; not part of user reorder list. */
export const SETTINGS_PLUGIN_ID = 'settings';

/**
 * Apply saved plugin id order for all plugins except Settings (always last).
 * When savedOrder is empty, registry order is preserved for the full list.
 */
export function applyPluginOrder(plugins: Plugin[], savedOrder: string[]): Plugin[] {
  if (!savedOrder.length) {
    return [...plugins];
  }

  const reorderable = plugins.filter((p) => p.id !== SETTINGS_PLUGIN_ID);
  const settingsPlugins = plugins.filter((p) => p.id === SETTINGS_PLUGIN_ID);

  const byId = new Map(reorderable.map((p) => [p.id, p]));
  const ordered: Plugin[] = [];
  for (const id of savedOrder) {
    if (id === SETTINGS_PLUGIN_ID) continue;
    const p = byId.get(id);
    if (p) {
      ordered.push(p);
      byId.delete(id);
    }
  }
  const remainder = Array.from(byId.values()).sort((a, b) => (a.order ?? 999) - (b.order ?? 999));
  const orderedReorderable = [...ordered, ...remainder];
  const settingsSorted = settingsPlugins.sort((a, b) => (a.order ?? 999) - (b.order ?? 999));
  return [...orderedReorderable, ...settingsSorted];
}

export function reorderIds<T>(list: T[], startIndex: number, endIndex: number): T[] {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  if (removed === undefined) return result;
  result.splice(endIndex, 0, removed);
  return result;
}
